var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKalfi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B8A16B",
    d: "M21.008 23.145H1.34C.604 23.145 0 22.571 0 21.87V9.18h22.349v12.689c0 .702-.603 1.276-1.341 1.276",
    transform: "translate(.312 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A6130",
    d: "M21.882 9.983l-8.084 5.841c-1.442 1.043-3.804 1.043-5.247 0L.468 9.984c-.623-.45-.623-1.187 0-1.637l9.769-7.06c.516-.371 1.359-.371 1.875 0l9.77 7.06c.623.45.623 1.186 0 1.636",
    transform: "translate(.312 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8A16B",
    d: "M6.547 19.038h9.207c.879 0 1.59-.718 1.59-1.601V1.6c0-.885-.711-1.601-1.59-1.601H6.547C5.67 0 4.958.716 4.958 1.601v15.836c0 .883.711 1.6 1.59 1.6",
    transform: "translate(.312 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8A16B",
    d: "M22.347 9.18c-.005.291-.158.582-.465.803l-8.084 5.841c-1.443 1.043-3.804 1.043-5.247 0L.467 9.984C.161 9.761.007 9.47.002 9.18H0v12.689c0 .702.604 1.276 1.341 1.276h19.667c.738 0 1.341-.574 1.341-1.276V9.18h-.002z",
    transform: "translate(.312 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A6130",
    d: "M21.882 8.508l-8.084 5.841c-1.442 1.043-3.804 1.043-5.247 0L.468 8.51C.16 8.286 0 8.98 0 8.98v.199h.002c.005.291.159.582.466.803l8.083 5.841c1.443 1.042 3.805 1.042 5.247 0l8.084-5.84c.306-.222.46-.513.465-.804h.002v-.2s-.16-.693-.467-.472",
    transform: "translate(.312 .5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKalfi);
export default __webpack_public_path__ + "static/media/kalfi.03139090568d69259cc47e2081dd99ac.svg";
export { ForwardRef as ReactComponent };